import * as Yup from "yup";

/**
 * El celular del usuario, del lado del navegador. Espejo de `CelularUtils` del backend.
 *
 * <p>Las dos reglas tienen que decir lo mismo: si el formulario acepta un numero que el backend
 * rechaza, la persona ve un error generico recien al apretar "Registrar" y sin saber cual de los
 * campos esta mal.
 */

/** Minimo y maximo de digitos. El maximo es el de E.164; el minimo, un numero corto de verdad. */
const MIN_DIGITOS = 8;
const MAX_DIGITOS = 15;

/** Deja solo digitos, conservando el `+` inicial. */
export const normalizarCelular = (celular) => {
    if (!celular) return "";

    const texto = String(celular).trim();
    const internacional = texto.startsWith("+");
    const digitos = texto.replace(/[^0-9]/g, "");

    if (!digitos) return "";

    return internacional ? "+" + digitos : digitos;
};

export const celularEsValido = (celular) => {
    const digitos = normalizarCelular(celular).replace(/[^0-9]/g, "");

    return digitos.length >= MIN_DIGITOS && digitos.length <= MAX_DIGITOS;
};

export const CELULAR_AYUDA =
    "Con característica y sin el 0 ni el 15. Ej: 1155667788";

/**
 * La validacion Yup del campo, para reusar en el registro y en el cartel de completar el perfil.
 *
 * <p>Acepta espacios, guiones y parentesis a proposito y valida sobre el numero ya limpio: la gente
 * escribe "(011) 15-5566-7788" y rebotarle eso es pelearse con el usuario por una cuestion de
 * formato que el codigo resuelve solo.
 */
export const celularSchema = Yup.string()
    .trim()
    .required("Requerido")
    .test(
        "celularValido",
        `Ingresá un celular válido (entre ${MIN_DIGITOS} y ${MAX_DIGITOS} dígitos)`,
        (value) => celularEsValido(value)
    );
